import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from '../../../helper/services/auth.service';
import { AdminConstant } from '../../../helper/constant/admin_constant';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  currentTheme = AdminConstant.currentTheme;
  isLoading: boolean = false;
  dynamicForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private themeService: NbThemeService,
    private authService: AuthService,

  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.dynamicForm.controls;
  }
  loadData() {
    this.dynamicForm = this.fb.group({
      email_id: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    })
    this.themeService.changeTheme(this.currentTheme);
  }

  submitForm(): void {
    console.log(this.dynamicForm.value, 'Form value');

    this.isLoading = true;

    this.authService
      .loginAdminUser(this.dynamicForm.value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe();
  }

}
